import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[layout]',
    standalone: false
})
export class LayoutDirective implements OnChanges {
    @Input() layout: string = '';

    private readonly _directiveName = 'layout';

    constructor(private el: ElementRef, private renderer: Renderer2) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['layout']) {
            this.updateLayout();
        }
    }


    private updateLayout(): void {
        const direction = this.normalizeDirection(this.layout);

        if (!direction) {
            console.warn(
                `[${this._directiveName}] Invalid value "${this.layout}". Allowed: 'row' or 'col'.`
            );
            return;
        }

        // base flex setup
        this.renderer.setStyle(this.el.nativeElement, 'display', 'flex');
        this.renderer.setStyle(this.el.nativeElement, 'flex-direction', direction);

        // ✅ ensure children stretch fully
        this.renderer.setStyle(this.el.nativeElement, 'align-items', 'stretch');
    }

    private normalizeDirection(value: string): 'row' | 'column' | null {
        switch (value) {
            case 'row':
                return 'row';
            case 'col':
                return 'column';
            default:
                return null;
        }
    }
}